<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير كشف مرتبات عن الشهر"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[
        name,
        desc,
        `تقرير كشف مرتبات عن الشهر ${convert_Month(month)}`,
      ]"
    >
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: ["month", "date", "name", "desc" , "FilterDeparmentClassificationsIds" ,"bankClassificationId"],
  data() {
    return {
      json_fields: {
        "ر.م": "num",
        "الرقم المالى": "financialNumber",
        "اسم الموظف": "employeeName",
        الإجمالى: "totalSalary",
        "الإستقطاعات (د.ل)": "totalDiscounts",
        "صافى المرتب": "netSalary",
      },
    };
  },
  methods: {
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }

      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let schema = {
        MonthDate: this.month,
        FilterDeparmentClassificationsIds: this.FilterDeparmentClassificationsIds == "" ? null : this.FilterDeparmentClassificationsIds,
        BankClassificationId: this.bankClassificationId,
      };
      let res = await axios.patch(
        `${env.HR()}/api/SalariesReports/GrossSalary`,
        schema,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      // for (let i = 0; i < result.data.data.items.length; i++) {
      //   let schema = {
      //     id: i + 1,
      //     financialNumber: result.data.data.items[i].financialNumber,
      //     employeeName: result.data.data.items[i].employeeName,
      //     totalSalary: result.data.data.items[i].totalSalary,
      //     totalDiscounts: result.data.data.items[i].totalDiscounts,
      //     netSalary: result.data.data.items[i].netSalary,
      //   };
      //   this.staffReportData.push(schema);
      // }

      // this.tableData = result.data.data;
      // this.name = result.data.data;

      res.data.data.items.forEach((item, i) => {
        item.num = i + 1;
      });

      return res.data.data.items;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
</style>